/**
 * @description 제품 타입
 */
export var PRODUCT_TYPE;
(function (PRODUCT_TYPE) {
    PRODUCT_TYPE["\uC6D0\uBD80\uC790\uC7AC"] = "\uC6D0\uBD80\uC790\uC7AC";
    PRODUCT_TYPE["\uBC18\uC81C\uD488"] = "\uBC18\uC81C\uD488";
    PRODUCT_TYPE["\uC644\uC81C\uD488"] = "\uC644\uC81C\uD488";
})(PRODUCT_TYPE || (PRODUCT_TYPE = {}));
